// import React from "react";
// import { ArrowLeft } from "lucide-react";
// import Logo from "../../components/common/Logo";
// import howToUseData from "../../data/howtouse.json";


//  function HowtoUse() {
//     return (
//         <>
//         <div className="min-h-screen bg-[#F4EFE8] px-4 md:px-10 py-6">
//             {/* LOGO */}
//             <div className="mb-8">
//                 <Logo />
//             </div>

//             {/* TOP BAR */}
//             <div className="bg-primary rounded-md h-[70px] flex items-center justify-between px-6 md:px-8">

//                 <h2 className="text-white text-[24px] md:text-[40px] font-semibold">
//                     How to use platform
//                 </h2>

//                 <button>
//                     <ArrowLeft
//                         size={40}
//                         className="text-white"
//                     />
//                 </button>

//             </div>
//             {/* CONTENT */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

//                 {/* LEFT */}
//                 <div className="mt-18">

//                     <h3 className="text-primary text-2xl underline mb-8">
//                         How to use platform
//                     </h3>

//                     <video
//                         controls
//                         className="w-full rounded-lg"
//                     >
//                         <source
//                             src="https://www.w3schools.com/html/mov_bbb.mp4"
//                             type="video/mp4"
//                         />
//                     </video>

//                 </div>

//                 {/* RIGHT */}
//                 <div className="mt-10">

//                     <h2 className="text-primary text-3xl font-semibold mb-8">
//                         Steps to use our platform:
//                     </h2>

//                     <ol className="list-decimal pl-6 space-y-4 text-[20px]">

//                         {howToUseData.map((item) => (
//                             <li key={item.id}>
//                                 {item.step}
//                             </li>
//                         ))}

//                     </ol>

//                 </div>

//         </div>
//        </div>
//         </>
//     )
// }
// export default HowtoUse;


import React, { useRef, useState } from "react";
import { ArrowLeft, Play } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import howToUseData from "../../data/howtouse.json";

function HowtoUse() {
    const navigate = useNavigate();
    const videoRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(151);

    /*
     * =========================================================
     * VIDEO PLAY / PAUSE
     * =========================================================
     */
    const toggleVideo = async () => {
        if (!videoRef.current) return;

        try {
            if (videoRef.current.paused) {
                await videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        } catch (error) {
            console.log("Video error:", error);
        }
    };

    /*
     * =========================================================
     * WATCH VIDEO HEADING
     * =========================================================
     */
    const handleWatchVideo = () => {
        navigate("/demo-session");
    };

    /*
     * =========================================================
     * VIDEO TIME UPDATE
     * =========================================================
     */
    const handleTimeUpdate = () => {
        if (!videoRef.current) return;

        setCurrentTime(videoRef.current.currentTime);
    };

    /*
     * =========================================================
     * VIDEO LOADED
     * =========================================================
     */
    const handleLoadedMetadata = () => {
        if (!videoRef.current) return;

        const videoDuration = videoRef.current.duration;

        if (Number.isFinite(videoDuration)) {
            setDuration(videoDuration);
        }
    };

    /*
     * =========================================================
     * FORMAT TIME
     * =========================================================
     */
    const formatTime = (time) => {
        if (!Number.isFinite(time)) return "0:00";

        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);

        return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    };

    /*
     * =========================================================
     * PROGRESS
     * =========================================================
     */
    const progress =
        duration > 0 ? Math.min((currentTime / duration) * 100, 100) : 0;

    /*
     * =========================================================
     * STEP CONTENT
     *
     * Existing JSON is used first.
     * If the old JSON does not contain the complete content,
     * these are the original 9 platform steps shown in the
     * reference design.
     * =========================================================
     */
    const referenceSteps = [
        "Register on our platform with a valid email ID and mobile number.",
        "View pre-recorded sample sessions before you decide.",
        "Subscribe to the service by making a payment.",
        "On subscribing, you receive an email with your unique student ID and batch details.",
        "On login, you can view your annual calendar and schedule.",
        "Log in at your session time to join the scheduled class.",
        "View past sessions, attempt tests, view solutions and view reports.",
        "You will receive notifications and alerts before each session.",
        "Every class is recorded, so you can always go back over it.",
    ];

    const jsonSteps = Array.isArray(howToUseData)
        ? howToUseData
            .map((item) => item?.step)
            .filter((step) => typeof step === "string" && step.trim())
        : [];

    /*
     * If JSON already contains the 9 old steps, use it.
     * Otherwise use the reference content.
     */
    const steps =
        jsonSteps.length >= referenceSteps.length
            ? jsonSteps
            : referenceSteps;

    return (
        <div className="min-h-screen min-h-[100dvh] bg-[#F7F3EA] text-[#17144B] overflow-x-hidden">

            {/* =====================================================
          PAGE CONTAINER
      ====================================================== */}

            <div className="w-full max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">

                {/* =====================================================
            HEADER / LOGO
        ====================================================== */}

                <header className="py-5 sm:py-6 lg:py-7">

                    <Link
                        to="/"
                        className="inline-flex flex-col items-start"
                    >

                        <div className="text-[24px] sm:text-[27px] lg:text-[29px] leading-none font-extrabold tracking-[-1.2px] whitespace-nowrap">

                            <span className="text-[#17144B]">
                                Insta
                            </span>

                            <span className="text-[#C95737]">
                                ED
                            </span>

                            <span className="text-[#17144B]">
                                {" "}Tuitions
                            </span>

                        </div>

                        <div className="mt-1.5 text-[9px] sm:text-[10px] lg:text-[11px] tracking-[0.15em] text-[#8C84A0] uppercase whitespace-nowrap">
                            ONLINE TUITIONS · CLASSES 6–10
                        </div>

                    </Link>

                </header>


                {/* =====================================================
            TOP HEADER
        ====================================================== */}

                <div
                    className="
            w-full
            min-h-[64px]
            sm:min-h-[68px]
            lg:min-h-[70px]
            bg-[#4035C9]
            rounded-[16px]
            sm:rounded-[18px]
            flex
            items-center
            justify-between
            gap-4
            px-5
            sm:px-7
            lg:px-8
          "
                >

                    <h1
                        className="
              text-white
              text-[18px]
              sm:text-[22px]
              lg:text-[24px]
              font-bold
              leading-tight
            "
                    >
                        How to use the platform
                    </h1>

                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        aria-label="Go back"
                        className="
              shrink-0
              w-9
              h-9
              sm:w-10
              sm:h-10
              flex
              items-center
              justify-center
              rounded-full
              text-white
              hover:bg-white/10
              transition-colors
            "
                    >
                        <ArrowLeft
                            size={21}
                            strokeWidth={2}
                        />
                    </button>

                </div>


                {/* =====================================================
            MAIN CONTENT
        ====================================================== */}

                <main
                    className="
            grid
            grid-cols-1
            lg:grid-cols-[1.02fr_0.98fr]
            gap-6
            lg:gap-8
            mt-7
            sm:mt-8
          "
                >

                    {/* ===================================================
              LEFT VIDEO
          ==================================================== */}

                    <section className="min-w-0">

                        {/* Clickable Heading */}

                        <button
                            type="button"
                            onClick={handleWatchVideo}
                            className="
                block
                mb-4
                text-left
                text-[#4035C9]
                text-[18px]
                sm:text-[20px]
                lg:text-[21px]
                font-medium
                hover:underline
              "
                        >
                            Watch the walkthrough video
                        </button>


                        {/* =================================================
                VIDEO CARD
            ================================================== */}

                        <div
                            className="
                w-full
                overflow-hidden
                rounded-[16px]
                border
                border-[#DED4C1]
                bg-[#F0EBDD]
              "
                        >

                            {/* Video area */}

                            <div
                                className="
                  relative
                  w-full
                  aspect-video
                  bg-[#F0EBDD]
                "
                            >

                                <video
                                    ref={videoRef}
                                    playsInline
                                    preload="metadata"
                                    onPlay={() => setIsPlaying(true)}
                                    onPause={() => setIsPlaying(false)}
                                    onEnded={() => setIsPlaying(false)}
                                    onTimeUpdate={handleTimeUpdate}
                                    onLoadedMetadata={handleLoadedMetadata}
                                    className="
                    absolute
                    inset-0
                    w-full
                    h-full
                    object-cover
                    bg-[#F0EBDD]
                  "
                                >
                                    <source
                                        src="https://www.w3schools.com/html/mov_bbb.mp4"
                                        type="video/mp4"
                                    />

                                    Your browser does not support the video tag.
                                </video>


                                {/* Center orange play button */}

                                {!isPlaying && (
                                    <button
                                        type="button"
                                        onClick={toggleVideo}
                                        aria-label="Play video"
                                        className="
                      absolute
                      left-1/2
                      top-1/2
                      -translate-x-1/2
                      -translate-y-1/2
                      w-[72px]
                      h-[72px]
                      sm:w-[80px]
                      sm:h-[80px]
                      rounded-full
                      bg-[#CB4B2D]
                      flex
                      items-center
                      justify-center
                      shadow-[0_10px_25px_rgba(203,75,45,0.25)]
                      hover:scale-105
                      transition-transform
                    "
                                    >
                                        <Play
                                            size={30}
                                            fill="white"
                                            strokeWidth={0}
                                            className="ml-1 text-white"
                                        />
                                    </button>
                                )}

                            </div>


                            {/* =================================================
                  CUSTOM VIDEO BAR
              ================================================== */}

                            <div
                                className="
                  h-[52px]
                  sm:h-[54px]
                  bg-[#5B587D]
                  flex
                  items-center
                  gap-3
                  sm:gap-4
                  px-4
                  sm:px-5
                "
                            >

                                {/* Play / Pause */}

                                <button
                                    type="button"
                                    onClick={toggleVideo}
                                    aria-label="Play or pause"
                                    className="
                    text-white
                    shrink-0
                    flex
                    items-center
                    justify-center
                  "
                                >

                                    {isPlaying ? (
                                        <span className="flex gap-[3px]">
                                            <span className="block w-[4px] h-[16px] rounded-sm bg-white" />
                                            <span className="block w-[4px] h-[16px] rounded-sm bg-white" />
                                        </span>
                                    ) : (
                                        <Play
                                            size={17}
                                            fill="white"
                                            strokeWidth={0}
                                        />
                                    )}

                                </button>


                                {/* Current Time */}

                                <span className="text-white text-[12px] sm:text-[13px] font-medium whitespace-nowrap">
                                    {formatTime(currentTime)}
                                </span>


                                {/* Progress */}

                                <div
                                    className="
                    flex-1
                    h-[5px]
                    rounded-full
                    bg-white/30
                    overflow-hidden
                  "
                                >
                                    <div
                                        className="
                      h-full
                      bg-white
                      rounded-full
                      transition-[width]
                      duration-100
                    "
                                        style={{
                                            width: `${progress || 0}%`,
                                        }}
                                    />
                                </div>


                                {/* Duration */}

                                <span className="text-white text-[12px] sm:text-[13px] font-medium whitespace-nowrap">
                                    {formatTime(duration)}
                                </span>

                            </div>

                        </div>

                    </section>


                    {/* ===================================================
              RIGHT STEPS
          ==================================================== */}

                    <section className="min-w-0">

                        <div
                            className="
                w-full
                bg-white
                border
                border-[#E5DCCB]
                rounded-[16px]
                shadow-[0_2px_7px_rgba(29,24,65,0.05)]
                px-6
                sm:px-7
                lg:px-8
                py-6
                sm:py-7
              "
                        >

                            {/* Heading */}

                            <h2
                                className="
                  text-[#4035C9]
                  text-[20px]
                  sm:text-[21px]
                  lg:text-[22px]
                  font-semibold
                  leading-tight
                  mb-5
                "
                            >
                                Steps to use our platform
                            </h2>


                            {/* =================================================
                  COMPLETE STEP LIST
              ================================================== */}

                            <ol
                                className="
                  list-decimal
                  pl-5
                  sm:pl-6
                  space-y-4
                  text-[15px]
                  sm:text-[16px]
                  leading-[1.55]
                  text-[#17144B]
                "
                            >

                                {steps.map((step, index) => (
                                    <li
                                        key={index}
                                        className="pl-1"
                                    >
                                        {step}
                                    </li>
                                ))}

                            </ol>

                        </div>

                    </section>

                </main>


                {/* =====================================================
            FOOTER
        ====================================================== */}

                <footer
                    className="
            border-t
            border-[#E6DDCE]
            mt-16
            sm:mt-20
            lg:mt-24
            py-6
            sm:py-7
          "
                >

                    <div
                        className="
              flex
              flex-wrap
              items-center
              justify-center
              gap-x-5
              gap-y-2
              text-[11px]
              sm:text-[13px]
            "
                    >

                        <Link
                            to="/terms-condition"
                            className="text-[#4035C9] hover:underline"
                        >
                            Terms of use
                        </Link>

                        <Link
                            to="/policy"
                            className="text-[#4035C9] hover:underline"
                        >
                            Privacy policy
                        </Link>

                        <span className="text-[#8C84A0]">
                            © 2026
                        </span>

                    </div>

                </footer>

            </div>
        </div>
    );
}

export default HowtoUse;